import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { toast } from "../../../../../core/helpers/message-helper";
import Wizard from "../../../../../core/ui/components/Wizard";
import { mapToSelect } from "../../../../../core/helpers/form-helper";
import {
    crearContrato,
    obtenerDatosCreacionContrato,
} from "../../../services/personas-service";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import AreasTab from "./areas-tab";
import ContratosTab from "./contratos-tab";
import GeneralTab from "./general-tab";

const tabFields = {
    0: ["entidad_pension_id", "contacto"],
    1: ["cargo_id", "parametro_riesgo_ocupacional_id", "observacion"],
    2: [
        "salario",
        "version_contrato_id",
        "tiempo_pago",
        "profesion_id",
        "bonificacion",
        "valor_poliza",
        "fin_contrato",
        "parametro_tipo_contrato_id",
        "inicio_contrato",
        "valor_forma_pago",
        "duracion_contrato",
        "valor_prestacional",
        "tipo_duracion_contrato",
        "parametro_servicio_contrato_id",
    ],
};

const FormContratos = ({ modalState }) => {
    const [selects, setSelects] = useState({
        positions: [],
        contractTypes: [],
        maritalStatuses: [],
        healthEntities: [],
        pensionEntities: [],
        occupationalRisks: [],
    });

    useEffect(async () => {
        const resp = await obtenerDatosCreacionContrato();
        if (!resp.status) return toast.error(resp.message);
        const { data } = resp;

        setSelects({
            positions: data.cargos.map((c) => mapToSelect(c.id, c.nombre)),
            contractTypes: data.tipos_contratos.map((tc) => {
                return { ...tc, value: tc.id, label: tc.nombre };
            }),
            professions: data.profesiones.map((p) =>
                mapToSelect(p.id, p.nombre)
            ),
            services: data.servicios_contratos.map((sc) =>
                mapToSelect(sc.id, sc.nombre)
            ),
            pensionEntities: data.entidades_pension.map((ep) =>
                mapToSelect(ep.id, ep.nombre)
            ),
            occupationalRisks: data.riesgos_ocupacionales.map((ro) =>
                mapToSelect(ro.id, `${ro.nombre} - ${ro.abreviacion}`)
            ),
        });
    }, []);

    const {
        reset,
        control,
        trigger,
        setValue,
        getValues,
        resetField,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            entidad_pension_id: "",
            contacto: "",
            fecha_ingreso: "",
            cargo_id: "",
            parametro_riesgo_ocupacional_id: "",
            observacion: "",
            parametro_tipo_contrato_id: "",
            duracion_contrato: "",
            tipo_duracion_contrato: "",
            inicio_contrato: "",
            fin_contrato: "",
            salario: "",
            bonificacion: "",
            valor_forma_pago: "",
            valor_poliza: "",
            valor_prestacional: "",
            parametro_servicio_contrato_id: "",
            tiempo_pago: "",
            version_contrato_id: "",
        },
    });

    const clearField = (field) => resetField(field);
    const getFieldValue = (field) => getValues(field);
    const setFieldValue = (field, value) => setValue(field, value);

    async function onNextTab(activeStep) {
        return await trigger(tabFields[activeStep]);
    }

    async function onSubmit(data) {
        data = {
            ...data,
            entidad_pension_id: data.entidad_pension_id.value,
            cargo_id: data.cargo_id.value,
            persona_id: modalState.data.personaId,
            profesion_id: data.profesion_id?.value,
            parametro_tipo_contrato_id: data.parametro_tipo_contrato_id.value,
            parametro_riesgo_ocupacional_id:
                data.parametro_riesgo_ocupacional_id.value,
            parametro_servicio_contrato_id:
                data.parametro_servicio_contrato_id?.value,
            tipo_duracion_contrato: data.tipo_duracion_contrato?.value,
            version_contrato_id: data.version_contrato_id.value,
        };

        const resp = await crearContrato(data);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        reset();
    }

    const tabs = [
        {
            nombre: "General",
            descripcion: "Información básica de la persona",
            icono: "fas fa-plus",
            componente: (
                <GeneralTab
                    errors={errors}
                    control={control}
                    selects={selects}
                />
            ),
        },
        {
            nombre: "Área",
            descripcion: "Información del área",
            icono: "fas fa-plus",
            componente: (
                <AreasTab
                    control={control}
                    errors={errors}
                    selects={selects}
                    clearField={clearField}
                />
            ),
        },
        {
            nombre: "Contrato",
            descripcion: "Información del contrato",
            icono: "fas fa-plus",
            componente: (
                <ContratosTab
                    errors={errors}
                    control={control}
                    selects={selects}
                    clearField={clearField}
                    getFieldValue={getFieldValue}
                    setFieldValue={setFieldValue}
                />
            ),
        },
    ];

    return (
        <Modal
            centered
            size={"lg"}
            isOpen={modalState.show}
            aria-labelledby="contained-modal-title-vcenter"
        >
            <ModalHeader className="bg-secondary text-white text-bold">
                Contratos
            </ModalHeader>
            <ModalBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Wizard tabs={tabs} onNextTab={onNextTab} />
                </form>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        key="close"
                        color="secondary"
                        onClick={() => {
                            reset();
                            modalState.close();
                        }}
                    >
                        <i className="fas fa-trash mr-2"></i>
                        Cancelar
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

FormContratos.propTypes = {
    modalState: PropTypes.object,
};

export default FormContratos;
